var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _g, _g2, _g3, _g4, _mask, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockedMicCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 139,
    viewBox: "0 0 117 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H117V26.2234H0V10Z",
    fill: "#911EEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.5952 12.9003C19.5952 15.6553 17.3363 17.8905 14.5486 17.8905C11.7608 17.8905 9.50195 15.6569 9.50195 12.9003C9.50195 10.1438 11.7608 7.91016 14.5486 7.91016C17.3363 7.91016 19.5952 10.1453 19.5952 12.9003Z",
    fill: "#FD0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M29.6882 17.8905C32.4754 17.8905 34.7348 15.6563 34.7348 12.9003C34.7348 10.1443 32.4754 7.91016 29.6882 7.91016C26.901 7.91016 24.6416 10.1443 24.6416 12.9003C24.6416 15.6563 26.901 17.8905 29.6882 17.8905Z",
    fill: "#F3F71B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M49.873 12.9003C49.873 15.6553 47.6141 17.8905 44.8264 17.8905C42.0402 17.8905 39.7798 15.6569 39.7798 12.9003C39.7798 10.1438 42.0387 7.91016 44.8264 7.91016C47.6141 7.91016 49.873 10.1453 49.873 12.9003Z",
    fill: "#11FF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3252 7.05469C94.035 7.05469 94.6104 7.63008 94.6104 8.33986V17.7815C94.6104 18.4913 94.035 19.0667 93.3252 19.0667V19.0667C92.6154 19.0667 92.04 18.4913 92.04 17.7815V8.33986C92.04 7.63008 92.6154 7.05469 93.3252 7.05469V7.05469Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.279 9.87228C107.579 10.5937 106.952 11.2915 106.171 11.2915H105.978C105.44 11.2915 105.015 10.8738 104.749 10.4058V10.4058C104.603 10.1438 104.415 9.92096 104.185 9.73718C103.956 9.55341 103.69 9.41264 103.39 9.31489C103.093 9.21713 102.77 9.16826 102.422 9.16826C101.793 9.16826 101.245 9.32271 100.778 9.63161C100.311 9.9366 99.9487 10.3824 99.6915 10.9689C99.4343 11.5515 99.3057 12.2592 99.3057 13.0921C99.3057 13.9484 99.4343 14.6679 99.6915 15.2505C99.9527 15.8331 100.317 16.273 100.784 16.5702C101.251 16.8673 101.791 17.0159 102.404 17.0159C102.749 17.0159 103.067 16.971 103.36 16.881C103.657 16.7911 103.92 16.6601 104.15 16.4881C104.379 16.3121 104.569 16.099 104.719 15.8487V15.8487C104.999 15.3956 105.427 14.9942 105.96 14.9966L106.149 14.9974C106.942 15.001 107.563 15.7123 107.221 16.4287C107.194 16.4859 107.165 16.5428 107.135 16.5995C106.87 17.1078 106.512 17.5633 106.061 17.9661C105.614 18.3649 105.08 18.6816 104.458 18.9163C103.841 19.147 103.142 19.2623 102.363 19.2623C101.278 19.2623 100.309 19.0199 99.4541 18.535C98.6032 18.0502 97.9305 17.3483 97.4358 16.4294C96.9451 15.5105 96.6997 14.3981 96.6997 13.0921C96.6997 11.7822 96.949 10.6678 97.4477 9.74891C97.9463 8.83003 98.623 8.13011 99.4778 7.64916C100.333 7.1643 101.294 6.92188 102.363 6.92188C103.067 6.92188 103.72 7.01963 104.322 7.21514C104.927 7.41064 105.463 7.69608 105.93 8.07146C106.397 8.44292 106.777 8.89846 107.07 9.43806C107.147 9.57757 107.216 9.72231 107.279 9.87228Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 90.5C21.8887 90.5 20.9443 90.1354 20.1665 89.4062C19.3887 88.6771 18.9998 87.7917 18.9998 86.75V79.25C18.9998 78.2083 19.3887 77.3229 20.1665 76.5938C20.9443 75.8646 21.8887 75.5 22.9998 75.5C24.1109 75.5 25.0554 75.8646 25.8332 76.5938C26.6109 77.3229 26.9998 78.2083 26.9998 79.25V86.75C26.9998 87.7917 26.6109 88.6771 25.8332 89.4062C25.0554 90.1354 24.1109 90.5 22.9998 90.5ZM21.6665 99.25V95.4062C19.3554 95.1146 17.4443 94.1458 15.9332 92.5C14.4221 90.8542 13.6665 88.9375 13.6665 86.75H16.3332C16.3332 88.4792 16.9832 89.9531 18.2832 91.1719C19.5832 92.3906 21.1554 93 22.9998 93C24.8443 93 26.4165 92.3906 27.7165 91.1719C29.0165 89.9531 29.6665 88.4792 29.6665 86.75H32.3332C32.3332 88.9375 31.5776 90.8542 30.0665 92.5C28.5554 94.1458 26.6443 95.1146 24.3332 95.4062V99.25H21.6665Z",
    fill: "#911EEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 134C13.7438 134 13.0964 133.755 12.5578 133.266C12.0193 132.776 11.75 132.188 11.75 131.5V116.5C11.75 115.812 12.0193 115.224 12.5578 114.734C13.0964 114.245 13.7438 114 14.5 114H31C31.7563 114 32.4036 114.245 32.9422 114.734C33.4807 115.224 33.75 115.812 33.75 116.5V122.125L39.25 117.125V130.875L33.75 125.875V131.5C33.75 132.188 33.4807 132.776 32.9422 133.266C32.4036 133.755 31.7563 134 31 134H14.5Z",
    fill: "#911EEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 41.6277L5.62816 41.2934L5.32767 41.6277L5.62816 41.9619L6 41.6277ZM18.48 42.1277C18.7561 42.1277 18.98 41.9038 18.98 41.6277C18.98 41.3515 18.7561 41.1277 18.48 41.1277V42.1277ZM9.78816 36.6657L5.62816 41.2934L6.37184 41.9619L10.5318 37.3343L9.78816 36.6657ZM5.62816 41.9619L9.78816 46.5896L10.5318 45.9211L6.37184 41.2934L5.62816 41.9619ZM6 42.1277H18.48V41.1277H6V42.1277Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 41.6277L36.492 41.2934L36.7924 41.6277L36.492 41.9619L36.1201 41.6277ZM23.6401 42.1277C23.364 42.1277 23.1401 41.9038 23.1401 41.6277C23.1401 41.3515 23.364 41.1277 23.6401 41.1277V42.1277ZM32.332 36.6657L36.492 41.2934L35.7483 41.9619L31.5883 37.3343L32.332 36.6657ZM36.492 41.9619L32.332 46.5896L31.5883 45.9211L35.7483 41.2934L36.492 41.9619ZM36.1201 42.1277H23.6401V41.1277H36.1201V42.1277Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2524 40.1926L52.9212 39.2316L51.919 35.5738",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1267 42.6214C54.1319 43.6818 53.7748 44.709 53.1138 45.5348C52.4529 46.3605 51.5273 46.9358 50.4887 47.1664C49.4501 47.3971 48.3602 47.2693 47.3973 46.8042C46.4345 46.339 45.6559 45.564 45.1891 44.6061C44.7222 43.6482 44.5949 42.5642 44.8279 41.5317C45.0609 40.4992 45.6404 39.5794 46.4714 38.923C47.3025 38.2666 48.3359 37.9125 49.4023 37.9187C50.4687 37.9249 51.5049 38.2911 52.3411 38.9573",
    stroke: "black",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63 42C63 37.0294 67.0294 33 72 33H116V51H72C67.0294 51 63 46.9706 63 42V42Z",
    fill: "#D9D9D9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7766 47.4258C79.0869 47.4258 78.504 47.1886 78.0278 46.7141C77.5516 46.2397 77.3134 45.6589 77.3134 44.9717C77.3134 44.2846 77.5516 43.7038 78.0278 43.2294C78.504 42.7549 79.0869 42.5177 79.7766 42.5177C80.4663 42.5177 81.0492 42.7549 81.5254 43.2294C82.0017 43.7038 82.2398 44.2846 82.2398 44.9717C82.2398 45.6589 82.0017 46.2397 81.5254 46.7141C81.0492 47.1886 80.4663 47.4258 79.7766 47.4258ZM79.7766 46.117C80.0941 46.117 80.365 46.0052 80.5895 45.7816C80.8139 45.558 80.9261 45.288 80.9261 44.9717C80.9261 44.6554 80.8139 44.3855 80.5895 44.1619C80.365 43.9383 80.0941 43.8265 79.7766 43.8265C79.4591 43.8265 79.1882 43.9383 78.9638 44.1619C78.7393 44.3855 78.6271 44.6554 78.6271 44.9717C78.6271 45.288 78.7393 45.558 78.9638 45.7816C79.1882 46.0052 79.4591 46.117 79.7766 46.117ZM70.745 45.6262V44.3173H75.9998V45.6262H70.745ZM72.2229 41.5361C71.5332 41.5361 70.9503 41.2988 70.4741 40.8244C69.9979 40.3499 69.7598 39.7691 69.7598 39.082C69.7598 38.3949 69.9979 37.8141 70.4741 37.3396C70.9503 36.8652 71.5332 36.6279 72.2229 36.6279C72.9126 36.6279 73.4956 36.8652 73.9718 37.3396C74.448 37.8141 74.6861 38.3949 74.6861 39.082C74.6861 39.7691 74.448 40.3499 73.9718 40.8244C73.4956 41.2988 72.9126 41.5361 72.2229 41.5361ZM72.2229 40.2272C72.5404 40.2272 72.8113 40.1154 73.0358 39.8918C73.2602 39.6682 73.3724 39.3983 73.3724 39.082C73.3724 38.7657 73.2602 38.4957 73.0358 38.2722C72.8113 38.0486 72.5404 37.9368 72.2229 37.9368C71.9054 37.9368 71.6345 38.0486 71.4101 38.2722C71.1857 38.4957 71.0734 38.7657 71.0734 39.082C71.0734 39.3983 71.1857 39.6682 71.4101 39.8918C71.6345 40.1154 71.9054 40.2272 72.2229 40.2272ZM75.9998 39.7364V38.4276H81.2545V39.7364H75.9998Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 42,
    r: 13.25,
    stroke: "black",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_308_117)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.6001,
    y: 82.2979,
    width: 51.48,
    height: 10.7979,
    rx: 5.39894,
    fill: "#B358FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_308_117)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.02,
    cy: 87.6964,
    rx: 7.02,
    ry: 6.94149,
    fill: "#FFFEFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_308_117)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.6001,
    y: 118.542,
    width: 51.48,
    height: 10.7979,
    rx: 5.39894,
    fill: "#B358FA"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_308_117)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.02,
    cy: 123.941,
    rx: 7.02,
    ry: 6.94149,
    fill: "#FFFEFF"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-outside-1_308_117",
    maskUnits: "userSpaceOnUse",
    x: 82.0278,
    y: 48,
    width: 25,
    height: 25,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 82.0278,
    y: 48,
    width: 25,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.891 61.4009L98.2762 61.6035L98.2762 61.6035C97.3441 61.9107 96.8781 62.0643 96.5431 62.3971C96.2082 62.7298 96.0514 63.1948 95.7379 64.1247L95.4872 64.8685C93.9179 69.5239 93.1332 71.8516 91.6968 71.8516C90.2604 71.8516 89.4757 69.5239 87.9064 64.8685L83.6146 52.1372C83.0571 50.4832 82.7783 49.6562 83.2138 49.2177C83.6494 48.7792 84.4782 49.0524 86.1359 49.5988L98.891 53.803C103.649 55.3712 106.028 56.1553 106.028 57.6019C106.028 59.0485 103.649 59.8327 98.891 61.4009Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.891 61.4009L98.2762 61.6035L98.2762 61.6035C97.3441 61.9107 96.8781 62.0643 96.5431 62.3971C96.2082 62.7298 96.0514 63.1948 95.7379 64.1247L95.4872 64.8685C93.9179 69.5239 93.1332 71.8516 91.6968 71.8516C90.2604 71.8516 89.4757 69.5239 87.9064 64.8685L83.6146 52.1372C83.0571 50.4832 82.7783 49.6562 83.2138 49.2177C83.6494 48.7792 84.4782 49.0524 86.1359 49.5988L98.891 53.803C103.649 55.3712 106.028 56.1553 106.028 57.6019C106.028 59.0485 103.649 59.8327 98.891 61.4009Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2762 61.6035L98.1181 61.1292L98.1197 61.1287L98.2762 61.6035ZM98.891 61.4009L99.0475 61.8758L99.0475 61.8758L98.891 61.4009ZM98.891 53.803L99.0475 53.3281L99.0475 53.3281L98.891 53.803ZM86.1359 49.5988L85.9794 50.0737L85.9794 50.0737L86.1359 49.5988ZM83.6146 52.1372L84.0884 51.9774L84.0884 51.9774L83.6146 52.1372ZM87.9064 64.8685L87.4326 65.0282L87.4326 65.0282L87.9064 64.8685ZM95.4872 64.8685L95.0134 64.7087L95.0134 64.7087L95.4872 64.8685ZM95.7379 64.1247L96.2117 64.2844L96.2117 64.2844L95.7379 64.1247ZM98.2762 61.6035L98.4343 62.0779L98.4327 62.0784L98.2762 61.6035ZM96.5431 62.3971L96.8955 62.7518L96.8955 62.7518L96.5431 62.3971ZM98.1197 61.1287L98.7345 60.926L99.0475 61.8758L98.4327 62.0784L98.1197 61.1287ZM98.7345 54.2778L85.9794 50.0737L86.2924 49.1239L99.0475 53.3281L98.7345 54.2778ZM84.0884 51.9774L88.3802 64.7087L87.4326 65.0282L83.1408 52.2969L84.0884 51.9774ZM95.0134 64.7087L95.2641 63.965L96.2117 64.2844L95.961 65.0282L95.0134 64.7087ZM88.3802 64.7087C89.17 67.0516 89.7465 68.7585 90.3002 69.8853C90.8738 71.0526 91.3068 71.3516 91.6968 71.3516V72.3516C90.6505 72.3516 89.9729 71.4868 89.4027 70.3263C88.8126 69.1254 88.2121 67.3407 87.4326 65.0282L88.3802 64.7087ZM95.961 65.0282C95.1815 67.3407 94.581 69.1255 93.9909 70.3263C93.4207 71.4868 92.7431 72.3516 91.6968 72.3516V71.3516C92.0868 71.3516 92.5198 71.0526 93.0934 69.8853C93.6471 68.7585 94.2236 67.0517 95.0134 64.7087L95.961 65.0282ZM98.7345 60.926C101.129 60.1369 102.874 59.5605 104.027 59.0053C104.602 58.7282 104.988 58.4753 105.226 58.2341C105.451 58.0055 105.528 57.8056 105.528 57.6019H106.528C106.528 58.1216 106.307 58.5622 105.938 58.9364C105.581 59.2982 105.075 59.6105 104.461 59.9063C103.234 60.4969 101.411 61.0966 99.0475 61.8758L98.7345 60.926ZM99.0475 53.3281C101.411 54.1072 103.234 54.7069 104.461 55.2976C105.075 55.5933 105.581 55.9057 105.938 56.2674C106.307 56.6416 106.528 57.0823 106.528 57.6019H105.528C105.528 57.3983 105.451 57.1984 105.226 56.9697C104.988 56.7286 104.602 56.4756 104.027 56.1985C102.874 55.6434 101.129 55.0669 98.7345 54.2778L99.0475 53.3281ZM98.4343 62.0779L98.4343 62.0779L98.1181 61.1292L98.1181 61.1292L98.4343 62.0779ZM98.4327 62.0784C97.453 62.4013 97.1271 62.5218 96.8955 62.7518L96.1908 62.0423C96.6292 61.6069 97.2353 61.4202 98.1197 61.1287L98.4327 62.0784ZM95.2641 63.965C95.5616 63.0826 95.7524 62.4777 96.1908 62.0423L96.8955 62.7518C96.664 62.9818 96.5413 63.3069 96.2117 64.2844L95.2641 63.965ZM85.9794 50.0737C85.1344 49.7952 84.5546 49.6055 84.1306 49.5315C83.703 49.4569 83.6062 49.5322 83.5686 49.5701L82.8591 48.8654C83.257 48.4647 83.7924 48.4574 84.3025 48.5464C84.8162 48.636 85.4797 48.8561 86.2924 49.1239L85.9794 50.0737ZM83.1408 52.2969C82.8675 51.486 82.6429 50.824 82.5498 50.3109C82.4574 49.8014 82.4611 49.266 82.8591 48.8654L83.5686 49.5701C83.531 49.6079 83.4563 49.7053 83.5338 50.1324C83.6106 50.5559 83.8042 51.1343 84.0884 51.9774L83.1408 52.2969Z",
    fill: "#C477FF",
    mask: "url(#path-20-outside-1_308_117)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_308_117",
    x: 50.6001,
    y: 79.2979,
    width: 59.48,
    height: 18.7979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_117"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_117",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_308_117",
    x: 50,
    y: 77.7549,
    width: 22.04,
    height: 21.8828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_117"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_117",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_308_117",
    x: 50.6001,
    y: 115.542,
    width: 59.48,
    height: 18.7979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_117"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_117",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_308_117",
    x: 50,
    y: 114,
    width: 22.04,
    height: 21.8828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_117"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_117",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedMicCameraIcon);
export default __webpack_public_path__ + "static/media/blocked_mic_camera_icon.18e4aaea3e729eebd74af976afe1f8aa.svg";
export { ForwardRef as ReactComponent };